import { SortDirection } from '@smooved/core';

export const defaultPageSize = 12;
export const defaultPageIndex = 0;
export const defaultSort: SortDirection = SortDirection.Asc;
export const defaultSortField = 'createdOn';
